import { combineReducers, PayloadAction } from '@reduxjs/toolkit'

import persistedStateReducer from './persistedStateSlice'
import authReducer from 'features/login/authSlice'
import userListReducer from 'features/users/UserListTable/userListSlice'
import userListReducerV2 from 'features/users/UserListTableV2/userListSlice'
import licenseReducer from 'features/licenses/licenseSlice'

const appReducer = combineReducers({
  persistedState: persistedStateReducer,
  auth: authReducer,
  userList: userListReducer,
  userListV2: userListReducerV2,
  license: licenseReducer,
})

export type RootState = ReturnType<typeof appReducer>

const rootReducer = (state: RootState | undefined, action: PayloadAction) => {
  if (action.type === 'auth/resetAuth') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}

export default rootReducer
